import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  mode: 'manual',
  fields: {
    values: [],
  },
  includeOtherFields: true,
};

export default defaults;
